/*
 * "Book a Call" gate (snippets/call-request.liquid).
 *
 * 1. Form submit → POST Rumi /call-request (lead + Slack alert) → reveal
 *    Calendly with name/email pre-filled.
 * 2. Calendly's `calendly.event_scheduled` postMessage → POST
 *    /call-request/<reference>/booked (second Slack alert).
 *
 * Booking must never depend on Rumi: if the request fails for any reason
 * other than a validation error, the calendar is still shown.
 */
(function () {
  if (window.QCCCallRequest) return;
  window.QCCCallRequest = true;

  var RUMI = 'https://rumi.queencitycoffeeroasters.com';
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  var active = null; // the gate whose calendar was revealed most recently

  function val(form, name) {
    var el = form.elements[name];
    return el ? String(el.value || '').trim() : '';
  }

  function withParams(url, params) {
    var parts = [];
    for (var k in params) {
      if (params[k]) parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k]));
    }
    if (!parts.length) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + parts.join('&');
  }

  function showCalendar(gate, name, email) {
    var cal = gate.querySelector('.cr-cal');
    var url = gate.getAttribute('data-calendly-url');
    gate.querySelector('.cr-form').hidden = true;
    cal.hidden = false;
    active = gate;
    if (cal.getAttribute('data-loaded')) return;
    cal.setAttribute('data-loaded', '1');

    var tries = 0;
    (function init() {
      if (window.Calendly && window.Calendly.initInlineWidget) {
        window.Calendly.initInlineWidget({
          url: url,
          parentElement: cal,
          prefill: { name: name, email: email }
        });
      } else if (tries++ < 25) {
        setTimeout(init, 200);
      } else {
        // widget.js blocked or slow: plain iframe with URL-param prefill.
        var f = document.createElement('iframe');
        f.src = withParams(url, { name: name, email: email, embed_type: 'Inline', embed_domain: location.hostname });
        f.title = 'Book a call';
        f.style.cssText = 'width:100%;height:630px;border:0;';
        cal.appendChild(f);
      }
    })();
  }

  function setError(gate, msg) {
    var el = gate.querySelector('.cr-error');
    el.textContent = msg || '';
    el.style.display = msg ? 'block' : 'none';
  }

  function onSubmit(e) {
    var form = e.target.closest('.cr-form');
    if (!form) return;
    e.preventDefault();
    var gate = form.closest('[data-call-request]');
    var data = {
      contact_name: val(form, 'contact_name'),
      business_name: val(form, 'business_name'),
      email: val(form, 'email'),
      phone: val(form, 'phone'),
      website: val(form, 'website'),
      interest: gate.getAttribute('data-interest'),
      page: location.pathname
    };

    if (!data.contact_name || !data.business_name || !data.email || !data.phone) {
      return setError(gate, 'Please fill in all four fields.');
    }
    if (!EMAIL_RE.test(data.email)) return setError(gate, 'Please enter a valid email address.');
    if (data.phone.replace(/\D/g, '').length < 10) return setError(gate, 'Please enter a phone number with area code.');
    setError(gate, '');

    var btn = form.querySelector('.m-submit');
    btn.disabled = true;
    var label = btn.innerHTML;
    btn.textContent = 'One moment…';

    function proceed() {
      btn.disabled = false;
      btn.innerHTML = label;
      showCalendar(gate, data.contact_name, data.email);
    }

    fetch(RUMI + '/call-request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) {
      if (r.status === 400) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          btn.disabled = false;
          btn.innerHTML = label;
          setError(gate, (j && j.error) ? j.error + '.' : 'Please check your details.');
        });
      }
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (r.ok && j && j.reference) gate.setAttribute('data-reference', j.reference);
        proceed();
      });
    }).catch(proceed);
  }

  function onMessage(e) {
    if (!/^https:\/\/([a-z0-9-]+\.)?calendly\.com$/.test(e.origin || '')) return;
    if (!e.data || e.data.event !== 'calendly.event_scheduled' || !active) return;
    var ref = active.getAttribute('data-reference');
    if (!ref || active.getAttribute('data-booked')) return;
    active.setAttribute('data-booked', '1');
    fetch(RUMI + '/call-request/' + encodeURIComponent(ref) + '/booked', { method: 'POST' }).catch(function () {});
  }

  document.addEventListener('submit', onSubmit);
  window.addEventListener('message', onMessage);
})();
